import React, { useEffect } from 'react';

import { OTP_CODE_LENGTH } from 'constants/otp';
import type { OtpVerifyResponse } from 'hooks/useOtpChallenge';
import { formatOtpPhone } from 'utils/otpScreenStorage';

import { OtpInlineBlock } from './OtpInlineBlock';
import classes from './OtpCodeScreen.module.scss';

export type OtpCodeScreenProps = {
  /** 'login' - «Код входа» (21:4837), 'register' - «Подтвердите телефон» (21:10034). */
  purpose: 'login' | 'register';
  phone: string;
  challengeId: string;
  channel?: string;
  cascadeAfter?: number;
  initialError?: string;
  onVerified: (data: OtpVerifyResponse) => void;
  onChangeNumber: () => void;
  onChallengeChange?: (data: { challengeId: string; channel: string; cascadeAfter: number }) => void;
};

/** Отдельный экран ввода кода. Вся логика OTP - в OtpInlineBlock, здесь только рамка экрана. */
export const OtpCodeScreen: React.FC<OtpCodeScreenProps> = ({
  purpose,
  phone,
  challengeId,
  channel,
  cascadeAfter,
  initialError,
  onVerified,
  onChangeNumber,
  onChallengeChange,
}) => {
  const number = formatOtpPhone(phone);
  useEffect(() => {
    // Экран заменяет длинную форму: показываем его с начала, а не с места кнопки отправки.
    window.scrollTo({ top: 0 });
    document.querySelectorAll('main, section').forEach((el) => {
      if (el.scrollTop > 0) el.scrollTop = 0;
    });
  }, []);
  return (
    <div className={classes.screen} data-testid='otp-code-screen'>
      <div className={classes.heading}>
        <h1 className={classes.title}>{purpose === 'login' ? 'Код входа' : 'Подтвердите телефон'}</h1>
        <p className={classes.subtitle}>
          {purpose === 'login'
            ? `Введите ${OTP_CODE_LENGTH} цифры для номера ${number}.`
            : `Введите код из ${OTP_CODE_LENGTH} цифр для номера ${number}.`}
        </p>
      </div>
      <OtpInlineBlock
        guest
        variant='screen'
        purpose={purpose}
        phone={phone}
        challengeId={challengeId}
        channel={channel}
        cascadeAfter={cascadeAfter}
        initialError={initialError}
        onVerified={onVerified}
        onChallengeChange={onChallengeChange}
        footer={
          <button type='button' onClick={onChangeNumber}>
            Изменить номер
          </button>
        }
      />
    </div>
  );
};
